var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPDATE_VAS_CONTROL_DATA_REQUEST, updateVasControlDataFailure, updateVasControlDataSuccess } from "../../actions";
import APIIN from "../../../utils/APIIN";
const onUpdateVasControlData = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            APIIN.postCompany(`company/admin/vas/${(_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.type}?tenantId=${action.payload.tenantId}`, action.payload.apiPayload)
                .then((data) => resolve(data))
                .catch((error) => reject(error));
        }
        catch (error) {
            if (error instanceof Error)
                reject(error);
        }
    }));
});
function* updateVasControlDataWorker(action) {
    try {
        const data = yield call(onUpdateVasControlData, action);
        yield put(updateVasControlDataSuccess(data));
    }
    catch (error) {
        yield put(updateVasControlDataFailure(error));
    }
}
export function* watchUpdateVasControlData() {
    yield takeLatest(UPDATE_VAS_CONTROL_DATA_REQUEST, updateVasControlDataWorker);
}
